/**
 * What a team owner can let a member do beyond what every member does
 * (TRA-1700). The API holds the list (app/schemas/team_permissions.py);
 * this names each one for the Members page.
 */

import { TeamInfoPermissionsItem } from '@/api/generated/model'

export type TeamPermission = TeamInfoPermissionsItem

interface PermissionCopy {
  /** The checkbox in the permissions dialog. */
  label: string
  /** Under the checkbox. */
  hint: string
  /** The mark on the member's row. */
  chip: string
}

export const PERMISSION_COPY: Record<TeamPermission, PermissionCopy> = {
  'audit_log.read': {
    label: 'Read the audit log',
    hint: "See who looked at or changed this team's data.",
    chip: 'Audit log',
  },
  'billing.read': {
    label: 'See billing',
    hint: 'See what this team is charged. Only the owner can change how it pays.',
    chip: 'Billing',
  },
}

/** Every permission, in the order the API lists them. */
export const TEAM_PERMISSIONS: readonly TeamPermission[] = Object.values(TeamInfoPermissionsItem)
